"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BasePolicyResponse {
    constructor(basePolicy, lastModifiedDate, lastModifiedBy) {
        this.policyNumber = basePolicy.policyNumber;
        this.partnerId = basePolicy.partnerId;
        this.lastModifiedDate = lastModifiedDate;
        this.lastModifiedBy = lastModifiedBy;
    }
}
exports.default = BasePolicyResponse;
//# sourceMappingURL=basePolicyResponse.class.js.map